module.exports = "/_next/static/images/intelligence-bg-49214418b1bccde2f605b6be3271f2ec.png";